import React from "react";
import { Typography } from "@mui/material";
import { Description as ContractsIcon } from "@mui/icons-material";
import PageContentLayout from "../components/layout/PageContentLayout";

const Contracts = () => {
  return (
    <PageContentLayout
      title="Contracts"
      subtitle="Manage school contracts and agreements"
      breadcrumbs={[
        { label: "Contracts", icon: <ContractsIcon sx={{ color: "#ffffff", fontSize: 18 }} /> },
      ]}
      backTo="/dashboard"
    >
      <Typography variant="body1" sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
        Contract management system coming soon...
      </Typography>
    </PageContentLayout>
  );
};

export default Contracts;
